import { render, staticRenderFns } from "./BtnNovaIndicacaoPcd.vue?vue&type=template&id=2f85f4ca&"
import script from "./BtnNovaIndicacaoPcd.vue?vue&type=script&lang=js&"
export * from "./BtnNovaIndicacaoPcd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports